import { localStorageService } from '@/service/storage.service'

// "나의 DB 문제 포함" 체크박스 영속화 정책: 디폴트 ON, 최종 생성 시점 값을 저장해 1단계 진입 시 복원한다
export const getStoredIncludeMyDbProblem = () =>
  localStorageService.getItem('MY_DB_SIMILAR_RECOMMEND_TOGGLE') ?? true

export const storeIncludeMyDbProblem = (includeMyDbProblem: boolean) => {
  localStorageService.setItem('MY_DB_SIMILAR_RECOMMEND_TOGGLE')(includeMyDbProblem)
}
